import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Modal, Button} from "react-bootstrap";
// eslint-disable-next-line no-restricted-imports
import {makeStyles} from "@material-ui/core/styles";
import {CircularProgress} from "@material-ui/core";
// eslint-disable-next-line no-restricted-imports
import Checkbox from '@material-ui/core/Checkbox';
import axios from "axios";
import {actions} from "app/hoc/Snackbar/snackbarRedux";

const {setSnackbar} = actions;

const useStyles = makeStyles({
    col: {
        "&:nth-child(2n+1)": {
            backgroundColor: "#EFF8FF"
        }
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
})

const UpdateVoidTicket = ({
                              show,
                              onHide,
                              barcode,
                              setBarcode,
                              onGetVoidTicket,
                              setShowVoidTicket,
                              data
                          }) => {
    const classes = useStyles();

    const dispatch = useDispatch();

    const [id, setId] = useState("");
    const [ticketGames, setTicketGames] = useState([]);
    const [columnPrice, setColumnPrice] = useState("");
    const [price, setPrice] = useState("");
    const [error, setError] = useState("");
    const [initialState, setInitialState] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e, index, option) => {
        let arr = [...initialState];
        arr[index][option] = Boolean(e.target.checked);
        setInitialState(arr);
        getPrice(initialState, columnPrice);

    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let allFalseArr = [];
        const body = {
            ticketGames: initialState,
            id: id
        }
        initialState.forEach((gameObj) => {
            let oneChecked = false;
            for (const option in gameObj) {
                if (option === "gameId") continue;
                if (gameObj[option] === true) {
                    oneChecked = true;
                }
            }
            allFalseArr.push(oneChecked)
        });
        if (allFalseArr.filter(item => item === false).length > 0) {
            setError("Bütün oyunlar üzrə proqnoz verilməlidir.");
        } else {
            setLoading(true)
            axios.put(`voidTickets/update`, body)
                .then((res) => {
                    setLoading(false);
                    onHide(false);
                    setBarcode(res.data);
                    onGetVoidTicket(res.data);
                    dispatch(setSnackbar({
                        variant: "success",
                        message: "Mərc edildi!"
                    }))
                })
                .catch((err) => {
                    setLoading(false)
                })
        }
    }


    const getPrice = (arr, columnPrice) => {
        let columnNumbers = [];
        for (let i = 0; i < arr.length; i++) {
            let num = arr[i].option1 === true && arr[i].optionX === true && arr[i].option2 === true
                ? 3 : arr[i].option1 === true && arr[i].optionX === true
                    ? 2 : arr[i].optionX === true && arr[i].option2 === true
                        ? 2 : arr[i].option1 === true && arr[i].option2 === true
                            ? 2 : 1;
            columnNumbers.push(num);
        }
        let multipliedNum = columnNumbers.reduce((prev, next) => prev * next, 1);
        let lastPrice = multipliedNum * columnPrice;

        setPrice(lastPrice.toFixed(2));
    }


    async function getData() {
        setLoading(true);
        try {
            const {data: circulationData} = await axios({
                method: "GET",
                url: "circulations/circulationGames",
                params: {
                    id: data?.circulationId
                }
            });
            setId(data?.id);
            setColumnPrice(circulationData?.columnPrice);
            setTicketGames(data.ticketGames);
            setPrice(data.price);
            const arr = data.ticketGames.map((game, index) => (
                {
                    gameId: game.gameId,
                    option1: game.options.option1,
                    optionX: game.options.optionX,
                    option2: game.options.option2
                }
            ));

            getPrice(arr, circulationData?.columnPrice);
            setInitialState(arr);
            setLoading(false);
        } catch (err) {
            setLoading(false)
        }
    }


    useEffect(() => {
        getData();
    }, [barcode]);


    return (
        <>
            <Modal
                size="md"
                show={show}
                onHide={onHide}
                aria-labelledby="create"
                centered
                className="modal pr-0"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="create">Proqnozları seçin.</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <div className="col-12 pl-4 pr-4">
                            {loading && (
                                <div className={classes.progresRoot}>
                                    <CircularProgress className={classes.progress}/>
                                </div>
                            )}

                            <div className="row">
                                {ticketGames.map((game, index) => (
                                    <div key={index} className={`col-12 col-md-12 col-lg-12 ${classes.col}`}>
                                        <div className="w-100 pt-2 pb-3 d-flex justify-content-between">
                                            <div
                                                className="d-flex align-items-center">{game.hostClub} - {game.guestClub}</div>
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <span>1</span>
                                                    <Checkbox
                                                        onChange={(e) => handleChange(e, index, "option1")}
                                                        checked={initialState[index]?.option1 || false}
                                                    />
                                                </div>
                                                <div>
                                                    <span>x</span>
                                                    <Checkbox
                                                        onChange={(e) => handleChange(e, index, "optionX")}
                                                        checked={initialState[index]?.optionX || false}
                                                    />
                                                </div>
                                                <div>
                                                    <span>2</span>
                                                    <Checkbox
                                                        onChange={(e) => handleChange(e, index, "option2")}
                                                        checked={initialState[index]?.option2 || false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="col-12 col-md-12 col-lg-12 d-flex justify-content-center">
                                    <span className="text-danger">{error}</span>
                                </div>
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            <span>Biletin qiyməti: <b>{price ? `${price} AZN` : ""}</b></span>
                            <div className="d-flex gap-2">
                                <Button className="mr-2" disabled={loading} type="submit">Yenilə</Button>
                                <Button className="btn-warning" type="button" onClick={() => {
                                    setShowVoidTicket(true);
                                    onHide(false);
                                }}>Geri</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
};

export default UpdateVoidTicket